import { icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var menuItem = [
    {
        disabled: false,
        icon: {
            color: "#006ac6",
            icon: icons.Edit,
            size: sizesIcon.standard,
        },
        id: "1",
        name: "Editar",
    },
    {
        disabled: false,
        icon: {
            color: "#006ac6",
            icon: icons.Delete,
            size: sizesIcon.standard,
        },
        id: "2",
        name: "Eliminar",
    },
];
export var buttonActionOptions = [
    {
        icons: icons.Menu,
        id: "1",
        name: "editar",
    },
    {
        icons: icons.Menu,
        id: "2",
        name: "eliminar",
    },
];
export var insurersView = [
    {
        id: "1",
        name: "GridView",
        active: true,
        icon: {
            icon: icons.GridView,
        },
    },
    {
        id: "2",
        name: "List",
        active: false,
        icon: {
            icon: icons.TableRows,
        },
    },
    {
        id: "3",
        name: "tableView",
        active: false,
        icon: {
            icon: icons.TableView,
        },
    },
];
export var statusPermission = [
    {
        id: "1",
        name: "Activo",
        value: "Active",
    },
    {
        id: "2",
        name: "Inactivo",
        value: "Inactive",
    },
];
export var selectValueDefault = "name";
